import { z } from "zod";

export const loginSchema = z.object({
    email : z.string().min(1,{message:"Email is Required"}).email({message:"Invalid Email"}),
    password : z.string().min(1,{message:"Password is Required"}),
});


export type ILoginInputs = z.infer<typeof loginSchema>
